module.exports = __webpack_public_path__ + "static/img/our-people-company-values-grid-4.3fd9063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-grid-4.jpg
// module id = iv4x
// module chunks = 0